import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { api } from '@/lib/api';
import type { InsuranceConfigFormDataDto } from '@/lib/ServerApi';
import { queryClient } from '@/providers/query-client';

export type InsuranceConfigFormLoaderData = InsuranceConfigFormDataDto;

/**
 * React Router loader for `/settings/insurance-config/create` and `.../:configId/edit`.
 *
 * Fetches {@link InsuranceConfigFormDataDto} via `api.insurance.getNewConfigFormData` / `getConfigFormData`, cached under
 * `['insurance','config','form', configId]` (create flow uses `undefined` as the last segment when `configId` is absent).
 *
 * @param params – React Router `params`; `configId` absent ⇒ create flow
 */
export async function insuranceConfigFormLoader({ params }: LoaderFunctionArgs): Promise<InsuranceConfigFormLoaderData> {
    const configId = params.configId;

    return queryClient.fetchQuery({
        queryKey: ['insurance', 'config', 'form', configId],
        queryFn: async () => {
            if (!configId) {
                const { data } = await api.insurance.getNewConfigFormData();
                if (!data) {
                    throw new Error('Missing insurance config form data');
                }
                return data;
            }
            const { data } = await api.insurance.getConfigFormData(configId);

            if (!data) {
                return redirect('/settings/insurance-config');
            }
            return data;
        },
    });
}
